import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useParams } from 'react-router';
import useKeypress from '../ownHooks/pressEsc';

var MonitorApi = require('monitor-api');


export default function TagesgruppenJahrUpdate ({ rowEntry, instance, reloadData }) {
    const { uniqueYear } = useParams();
    const [showModal, setShowModal] = useState(false);
    const [value, setValue] = useState(rowEntry.anzTage);
    const [update, setUpdate] = useState(new MonitorApi.TagesgruppeJahrUpdate());

    useEffect(() => {
        if (showModal) {
            setValue(rowEntry.anzTage);
        }
    }, [showModal, rowEntry.anzTage])

    const changeValue = event => {
        event.preventDefault();
        if (event.target.value >= 0) {
            setValue(event.target.value);
            update.anz_tage = event.target.value;
            setUpdate(update);
        } else {
            setValue("");
        }
    }

    const newChanges = () => {
        if (parseInt(value) === parseInt(rowEntry.anzTage) || value === "") {
            return false;
        }
        return true;
    }

    const saveChanges = event => {
        event.preventDefault();
        instance.updateTgInJahr(rowEntry.jahr, rowEntry.idGruppe, update, 
            (error, data) => {
                if (error) {
                    console.log(error);
                    alert('irgendwas ging schief...');
                } else {
                    setShowModal(false);
                    reloadData(uniqueYear);
                }
        })
    }

    useKeypress('Escape', () => {
        cancel();
    });

    const cancel = () => {
        setValue(rowEntry.anzTage);
        setShowModal(false);
    }


    return (
        <div>
            <button className="update-bttn" onClick={() => setShowModal(true)}>Bearbeiten</button>
            <Modal isOpen={showModal} className="modal" >
                <button className="bttn-close-modal" onClick={cancel}>&#10007; </button>

                <div>
                    <h4>Änderungen eintragen für {rowEntry.jahr}:</h4>
                    <label>Tagesgruppe: {rowEntry.gruppe}
                        <input type="number" min="0" value={value} onChange={changeValue}/>
                    </label>
                </div>
                
                <button disabled={!newChanges()} onClick={saveChanges}>Speichern</button>
                <button onClick={cancel}>Abbruch</button>
            </Modal>
        </div>
    )
}